import SectionStartTemplate from '../../../templates/sectionStart';
import { SectionStatus } from '../../../sections/types';

import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { Text } from '@chakra-ui/react';

export interface IProps {
  personalInfoStatus: SectionStatus;
  consentsStatus: SectionStatus;
  financeStatus: SectionStatus;
}
type Props = IProps;

const HistorySectionStart = (props: Props) => {
  const { navigateBackward, navigateForward, navigateToStudentDashboard } = useCustomNavigate();

  const onPrevious = () => navigateBackward();
  const onNext = () => navigateForward();
  const onBackToTaskList = () => navigateToStudentDashboard();

  return (
    <SectionStartTemplate
      section="Section 2 - Your History"
      minsToComplete={10}
      section1={props.personalInfoStatus}
      section2={SectionStatus.todo}
      section3={props.consentsStatus}
      section4={props.financeStatus}
      onNext={onNext}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
    >
      <Text fontSize={'lg'}>
        Questions will cover your travel and academic history as well as the circumstances of your study trip to the UK
      </Text>
    </SectionStartTemplate>
  );
};

export default HistorySectionStart;
